import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { PrimaryHeaderViewModel } from 'autogen/swagger/all';
import { HeaderLogoAltText } from 'autogen/translation-keys/trans-website-imagealttext';
import Logo from 'components/Icon/Logo';
import QuickSearch from 'components/QuickSearch';
import { SideMenuOpenerButton } from 'components/sideMenu';
import { breakpoint, sizes } from 'variables';
import SessionMenu from '../../SessionMenu/SessionMenu';
import Header from './Header';

/* #region  styles */
const LogoLink = styled.a`
    display: flex;
    align-items: center;
`;
const StyledLogo = styled(Logo)`
    width: 72px;

    ${breakpoint.up('375px')} {
        width: 80px;
        height: 40px;
    }

    ${breakpoint.up('768px')} {
        width: 88px;
        height: 40px;
    }
`;

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
    align-items: center;
    gap: 12px;

    ${breakpoint.up(sizes.sm)} {
        gap: 16px;
    }
`;
/* #endregion */

function LeftContent() {
    const { t } = useTranslation();

    return (
        <Container>
            <SideMenuOpenerButton />
            <LogoLink href="/" aria-label={t(HeaderLogoAltText)}>
                <StyledLogo />
            </LogoLink>
        </Container>
    );
}

export default function PrimaryHeader({ model: { sessionMenu } }: { model: PrimaryHeaderViewModel }) {
    const { searchText } = sessionMenu;

    return (
        <Header
            leftSlot={<LeftContent />}
            centerSlot={<QuickSearch searchText={searchText} />}
            rightSlot={<SessionMenu model={sessionMenu} />}
        />
    );
}
